import { render, staticRenderFns } from "./VueBootstrapTypeaheadList.vue?vue&type=template&id=2c5fcaa4&scoped=true&"
import script from "./VueBootstrapTypeaheadList.vue?vue&type=script&lang=js&"
export * from "./VueBootstrapTypeaheadList.vue?vue&type=script&lang=js&"
import style0 from "./VueBootstrapTypeaheadList.vue?vue&type=style&index=0&id=2c5fcaa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5fcaa4",
  null
  
)

export default component.exports